import type {Directive} from "vue";
import intlTelInput, {CountryData} from "intl-tel-input/index.js";
import {getRootElement} from "@/utilities/domUtils";

// @ts-ignore
const intlBaseUrl = import.meta.env.VITE_NF_BASE_URL + 'dist/vendor/intl-tel-input/';
let mountCount = 0;
let link: HTMLLinkElement|undefined;

const NfTel: Directive<HTMLInputElement> = {
    beforeMount(el) {
        if (!mountCount++) {
            link = document.createElement('link');
            link.rel   = 'stylesheet';
            link.href  = intlBaseUrl+'css/intlTelInput.css';
            getRootElement(el).appendChild(link);
        }
    },
    mounted(el, binding) {
        const iti = intlTelInput(
            el,
            {
                initialCountry: "pl",
                utilsScript: intlBaseUrl+'js/utils.js',
            }
        );

        function updateValue(number: string) {
            el.value = number;
            el.dispatchEvent(new Event('input'));
        }

        function ensurePlusSign() {
            const data: CountryData = iti.getSelectedCountryData();
            if (!el.value.startsWith('+')) {
                el.value = '+' + data.dialCode +el.value.replace(/^(\+*)/, '');
            }
        }

        el.addEventListener('input', () => {
            ensurePlusSign();
            const number = iti.getNumber();
            if (el.value !== number && iti.isValidNumber()) {
                updateValue(number);
            }
        });
        el.addEventListener('countrychange', () => {
            updateValue(iti.getNumber());
        });

        if (!binding.value && !el.value) {
           ensurePlusSign();
        }
    },
    unmounted() {
        if (!--mountCount) {
            link?.remove();
            link = undefined;
        }
    }
};

export default NfTel;
